export default class UserMapping {

    mapData(user) {
        return {
            id: user ? user.id : null,
            username: user ? user.username : null,
            email: user ? user.email : null,
            origin: user ? user.origin : null,
            firstname: user ? user.firstname : null,
            lastname: user ? user.lastname : null,
            owner_id: user ? user.owner_id : null,
            owner: user ? user.owner : null,
            entity_id: user ? user.entity_id : null,
            entity: user ? user.entity : null,
            role_id: user ? (user.admin ? '0' : user.role_id) : null,
            role: user ? (user.admin ? {name: 'Super-Admin'} : user.role) : null,
            admin: user ? user.admin : false,
            active: user ? user.active : true,
            source: user ? user.source : 'internal',
            enac_id: user ? user.enac_id : null,
            avatar: user ? user.avatar : null,
            name: user ? user.name : null,
            cohorts: user ? user.cohorts : null,
            permissions: user ? user.permissions : null,
            created_at: user ? user.created_at : null,
        }
    }

    unmapData(data) {
        let user = {...data}
        if (user.role_id === '0') {
            user.role_id = null
            user.admin = true
        } else {
            user.admin = false
        }
        return user
    }
}
